import ModelTypeConstants from 'constants/ModelTypeConstants';
import {OligoAwareFolderItemType} from 'constants/RegistryConstants';
import {BenchlingAppType, BenchlingAppSubtype} from 'graphql-client/__generated/graphqlGlobalTypes';

export {BenchlingAppType};
export {BenchlingAppSubtype};

export enum NestedParentDependencyType {
  workflow_task_schema_output = 'workflow_task_schema_output',
}

export const MODEL_CONSTANT_BY_APP_CONFIG_TYPE = {
  // [BenchlingAppType.workflow_output]: ModelTypeConstants.PROCESS_OUTPUT,
  // [BenchlingAppType.workflow_task]: ModelTypeConstants.PROCESS_TASK,
  [BenchlingAppType.dna_sequence]: ModelTypeConstants.SEQUENCE,
  [BenchlingAppType.dna_oligo]: ModelTypeConstants.DNA_OLIGO,
  [BenchlingAppType.aa_sequence]: ModelTypeConstants.PROTEIN,
  [BenchlingAppType.custom_entity]: ModelTypeConstants.BASIC_FOLDER_ITEM,
  [BenchlingAppType.mixture]: ModelTypeConstants.MIXTURE,
  [BenchlingAppType.molecule]: ModelTypeConstants.MOLECULE,
  [BenchlingAppType.rna_oligo]: ModelTypeConstants.RNA_OLIGO,
  [BenchlingAppType.rna_sequence]: ModelTypeConstants.RNA_SEQUENCE,
};

export const SCALAR_CONFIGURATIONS = [
  BenchlingAppType.boolean,
  BenchlingAppType.date,
  BenchlingAppType.datetime,
  BenchlingAppType.float,
  BenchlingAppType.integer,
  BenchlingAppType.secure_text,
  BenchlingAppType.text,
  BenchlingAppType.json,
];

export interface ScalarDependencyTypeToValueTSType {
  [BenchlingAppType.boolean]: boolean | null;
  [BenchlingAppType.date]: string | null;
  [BenchlingAppType.datetime]: string | null;
  [BenchlingAppType.float]: number | null;
  [BenchlingAppType.integer]: number | null;
  [BenchlingAppType.secure_text]: string | null;
  [BenchlingAppType.text]: string | null;
  [BenchlingAppType.json]: string | null;
}

export type BenchlingAppParentDependencyType =
  | BenchlingAppType.dropdown
  | BenchlingAppType.result_schema
  | BenchlingAppType.run_schema
  | BenchlingAppType.request_schema
  | BenchlingAppType.plate_schema
  | BenchlingAppType.box_schema
  | BenchlingAppType.location_schema
  | BenchlingAppType.container_schema
  | BenchlingAppType.entry_schema
  | BenchlingAppType.entity_schema
  | BenchlingAppType.workflow_task_schema;

const parentDependencyTypes = [
  BenchlingAppType.dropdown,
  BenchlingAppType.result_schema,
  BenchlingAppType.request_schema,
  BenchlingAppType.run_schema,
  BenchlingAppType.plate_schema,
  BenchlingAppType.box_schema,
  BenchlingAppType.location_schema,
  BenchlingAppType.container_schema,
  BenchlingAppType.entry_schema,
  BenchlingAppType.entity_schema,
  BenchlingAppType.workflow_task_schema,
];

export function isParentDependencyType(type: BenchlingAppType): type is BenchlingAppParentDependencyType {
  return parentDependencyTypes.includes(type);
}

export const SUBDEPENDENCY_KEY_BY_TYPE: {
  [k in BenchlingAppParentDependencyType]: string;
} = {
  [BenchlingAppType.result_schema]: 'fieldDefinitions',
  [BenchlingAppType.request_schema]: 'fieldDefinitions',
  [BenchlingAppType.run_schema]: 'fieldDefinitions',
  [BenchlingAppType.plate_schema]: 'fieldDefinitions',
  [BenchlingAppType.box_schema]: 'fieldDefinitions',
  [BenchlingAppType.location_schema]: 'fieldDefinitions',
  [BenchlingAppType.container_schema]: 'fieldDefinitions',
  [BenchlingAppType.entry_schema]: 'fieldDefinitions',
  [BenchlingAppType.entity_schema]: 'fieldDefinitions',
  [BenchlingAppType.dropdown]: 'options',
  [BenchlingAppType.workflow_task_schema]: 'fieldDefinitions',
};

export const subtypeToModelTypeMapping: {[x: string]: OligoAwareFolderItemType} = {
  [BenchlingAppSubtype.aa_sequence]: ModelTypeConstants.PROTEIN,
  [BenchlingAppSubtype.dna_sequence]: ModelTypeConstants.SEQUENCE,
  [BenchlingAppSubtype.mixture]: ModelTypeConstants.MIXTURE,
  [BenchlingAppSubtype.molecule]: ModelTypeConstants.MOLECULE,
  [BenchlingAppSubtype.custom_entity]: ModelTypeConstants.BASIC_FOLDER_ITEM,
  [BenchlingAppSubtype.dna_oligo]: ModelTypeConstants.DNA_OLIGO,
  [BenchlingAppSubtype.rna_oligo]: ModelTypeConstants.RNA_OLIGO,
  [BenchlingAppSubtype.rna_sequence]: ModelTypeConstants.RNA_SEQUENCE,
};
